mutation POEntityDocumentUnretireBalance(
  $input: EntityDocumentUnretireBalanceInput!
) {
  entityDocumentUnretireBalance(input: $input) {
    entityDocument {
      id
      _unretirePrivilege
      documentTypes {
        id
        documentType
        isAccountingDocument
        isSigningRequired
        _isAppliableDocumentType
      }
      documentAppliedAmounts {
        id
        appliedTotal
        overageTotal
        retiredTotal
        usedTotal
        remainingTotal
        _isRemainingAmountAvailable
        _isRetiringBalanceAllowed
      }
      currency {
        isoCode
      }
      indexName
      indexAmount
      indexDescription
      indexReferenceNumber
      _rowTimestamp
    }
  }
}
